import * as React from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import { Button, Label, Input, InputGroup, InputGroupText, Table } from "reactstrap";
import Icon from "@material-ui/core/Icon";
import * as _ from "lodash";
import { scwApi } from "../../services/Api";
import { IndicatorDTO } from "../../services/models/IndicatorDTO";
import { LanguageMetadataDTO } from "../../services/models/LanguageMetadataDTO";
import ButtonCustomGroup from "../ButtonCustomGroup";
import PanelSelectIndicator from "./PanelSelectIndicator";

import "./PanelSelectData.css";


type PanelSelectDataProps = {
    allowClear?: boolean;
    allowSearch: boolean;
    caption?: string;
    caption2?: string
    categoryId?: number;
    dataIndicatorsGet: Function,
    dataIndicatorsGetMetadata: Function;
    dataIndicatorsGetOfCategory: Function,
    dataIndicatorsSearch: Function,
    locale: string[2],
    indicator?: IndicatorDTO | undefined,
    onClearSelection?: any,
    onSelected?: any,
    scwApiIndicatorsGet: Function,
    scwApiIndicatorsGetMetadata: Function;
    scwApiIndicatorsGetOfCategory: Function,
    scwApiIndicatorsSearch: Function,
};

type PanelSelectDataState = {
    allowSearch: boolean;
    categoryId?: number;
    indicators: IndicatorDTO[];
    indicator?: IndicatorDTO | undefined;
    indicatorMetadata?: LanguageMetadataDTO[] | undefined;
    isSelectionExpanded: boolean;
    locale: string[2];
    searchText: string;
}

class PanelSelectData extends React.Component<PanelSelectDataProps, PanelSelectDataState> {

    inputRef: any = undefined;

    constructor(props: Readonly<PanelSelectDataProps>) {
        super(props);

        this.state = {
            allowSearch: props.allowSearch,
            indicators: [],
            indicator: props.indicator,
            isSelectionExpanded: false,
            locale: props.locale,
            searchText: "",
        };
    } // constructor

    static getDerivedStateFromProps(nextProps: Readonly<PanelSelectDataProps>, prevState: PanelSelectDataState):
        Partial<PanelSelectDataState> | null {

        // Load metadata of selected indicator
        let nextStateIndicatorMetadata = undefined;

        if (!_.isNil(nextProps.indicator)) {
            const loIndicatorsGetMetadataApiObject =
                nextProps.dataIndicatorsGetMetadata(nextProps.locale, nextProps.indicator.indicatorID);

            if (loIndicatorsGetMetadataApiObject.isSuccess)
                nextStateIndicatorMetadata = loIndicatorsGetMetadataApiObject.data;
            else if (!loIndicatorsGetMetadataApiObject.isLoading)
                nextProps.scwApiIndicatorsGetMetadata(nextProps.locale, nextProps.indicator.indicatorID);
        }

        // Load indicators 
        let nextStateIndicators: IndicatorDTO[] = [];

        if (!_.isNil(nextProps.categoryId)) {
            const loIndicatorsGetOfCategoryApiObject =
                nextProps.dataIndicatorsGetOfCategory(nextProps.locale, nextProps.categoryId);

            if (
                !loIndicatorsGetOfCategoryApiObject.isSuccess
                && !loIndicatorsGetOfCategoryApiObject.isLoading
            )
                nextProps.scwApiIndicatorsGetOfCategory(nextProps.locale, nextProps.categoryId);

            if (loIndicatorsGetOfCategoryApiObject.isSuccess)
                nextStateIndicators = loIndicatorsGetOfCategoryApiObject.data;
        }
        else if (nextProps.allowSearch) {
            const loIndicatorsSearchApiObject =
                nextProps.dataIndicatorsSearch(nextProps.locale, prevState.searchText);

            if (loIndicatorsSearchApiObject.isSuccess)
                nextStateIndicators = loIndicatorsSearchApiObject.data;
        }

        return {
            categoryId: nextProps.categoryId,
            indicators: nextStateIndicators,
            indicator: nextProps.indicator,
            indicatorMetadata: nextStateIndicatorMetadata,
            locale: nextProps.locale,
        };
    } // getDerivedStateFromProps

    getMetadataValue(asKey: string): string {
        if (_.isNil(this.state.indicatorMetadata))
            return "";

        const loLanguageMetadata =
            _.find(
                this.state.indicatorMetadata,
                aoMetadata => (aoMetadata.key === asKey)
            );

        if (!_.isNil(loLanguageMetadata))
            return loLanguageMetadata.value.split("[").join("<").split("]").join(">");

        return "";
    } // getMetadataValue

    onClearSelection() {
        if (_.isNil(this.props.onClearSelection))
            return;

        this.setState({
            isSelectionExpanded: false,
        }, () => {
            this.props.onClearSelection();
        });
    } // onClearSelection

    onInputChange(e: any) {
        this.setState({
            searchText: e.target.value,
        });
    } // onInputChange

    onInputKeyDown(e: any) {
        if (e.keyCode == 13)
            this.onSearchClick();
    } // onInputKeyDown

    onSearchClick() {
        if (_.isEmpty(this.state.searchText))
            return;

        this.props.scwApiIndicatorsSearch(this.props.locale, this.state.searchText);
    } // onSearchClick

    onSelectClick() {
        this.setState(
            prevState => (
                {
                    isSelectionExpanded: !prevState.isSelectionExpanded,
                }
            )
        );
    } // onSelectClick

    onPanelSelectIndicatorClickItem(aoIndicator: any) {
        if (_.isNil(this.props.onSelected))
            return;

        this.setState({
            isSelectionExpanded: false,
        }, () => {
            this.props.onSelected(aoIndicator);
        });
    } // onPanelSelectIndicatorClickItem

    render() {
        // console.log("(PanelSelectData.render)", this.props, this.state);

        return (
            <div className="panel-select-data">
                <div className="thick-bar"></div>
                <Table borderless>
                    <tbody>
                        <tr className="row-indicator">
                            <td className="column1">
                                <span className="panel-title">
                                    {_.isNil(this.props.caption) ? I18n.t("frontend_select_data_panel_title") : this.props.caption}
                                </span>
                                {
                                    !_.isNil(this.state.indicator) && (this.props.allowClear === true) && (
                                        <span className="clear-selection" onClick={() => this.onClearSelection()}>
                                            {I18n.t("frontend_text_clear_selection")}
                                        </span>
                                    )
                                }



                            </td>
                            <td className="column2">
                                <span className="indicator-name">
                                    {_.isNil(this.state.indicator) ? "" : this.state.indicator.name}
                                </span>
                            </td>
                            <td className={`column3${this.state.isSelectionExpanded ? " active" : ""}`} rowSpan={_.isNil(this.state.indicator) ? 1 : 2}>
                                <div className="select-data" onClick={() => this.onSelectClick()}>
                                    {I18n.t("frontend_text_select_data_panel_button_select")}
                                    <span className={this.state.isSelectionExpanded ? "chevron" : "chevron bottom"}></span>
                                </div>
                            </td>
                        </tr>
                        {
                            !_.isNil(this.state.indicator) && (
                                <tr>
                                    <td className="column1"></td>
                                    <td className="column2">
                                        <div className="indicator-attribute">
                                            <div className="indicator-attribute-name">
                                                {!_.isNil(this.state.indicator) && I18n.t("frontend_text_select_data_panel_indicator_type_of_data")}
                                            </div>
                                            <div className="indicator-attribute-value">
                                                {_.isNil(this.state.indicator) ? "" : this.state.indicator.typeName}
                                            </div>
                                        </div>
                                        <div className="indicator-attribute">
                                            <div className="indicator-attribute-name">
                                                {!_.isNil(this.state.indicator) && I18n.t("frontend_text_select_data_panel_indicator_source")}
                                            </div>
                                            <div
                                                className="indicator-attribute-value"
                                                dangerouslySetInnerHTML={{ __html: _.isNil(this.state.indicator) ? "" : this.getMetadataValue("dc:publisher") }}>
                                            </div>
                                        </div>
                                        <div className="indicator-attribute">
                                            <span className="indicator-attribute-name">
                                                {null && I18n.t("frontend_text_select_data_panel_indicator_source_and_quality")}
                                            </span>
                                            <span className="indicator-attribute-value">
                                                {_.isNil(this.state.indicator) ? "" : null}
                                            </span>
                                        </div>
                                        <div className="indicator-attribute">
                                            <span className="indicator-attribute-name">
                                                {null && I18n.t("frontend_text_select_data_panel_indicator_publication")}
                                            </span>
                                            <span className="indicator-attribute-value">
                                                {_.isNil(this.state.indicator) ? "" : null}
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            )
                        }
                        {
                            (this.state.isSelectionExpanded) && (this.state.allowSearch) && (
                                <tr className="row-select-indicator">
                                    <td className="column1-search center-vertically">
                                        <span className="select-panel-row-title">
                                            {I18n.t("frontend_text_select_data_panel_search_the_catalogue")}
                                        </span>
                                    </td>
                                    <td colSpan={2}>
                                        <div className="select-panel-search-catalogue-input-container">
                                            <InputGroup>
                                                <InputGroupText>
                                                    <Icon>search</Icon>
                                                </InputGroupText>
                                                <Input
                                                    ref={(aoInput: any) => { this.inputRef = aoInput; }}
                                                    autoComplete="off"
                                                    autoCorrect="off"
                                                    autoCapitalize="off"
                                                    id="panel-search-input"
                                                    placeholder={I18n.t("frontend_text_select_data_panel_search_the_catalogue_placeholder_text")}
                                                    spellCheck={false}
                                                    value={this.state.searchText}
                                                    onChange={(e) => { this.onInputChange(e); }}
                                                    onKeyDown={(e) => { this.onInputKeyDown(e); }}
                                                />
                                                <div className="search-panel-input-container-button">
                                                    <Button onClick={() => { this.onSearchClick() }}>
                                                        {I18n.t("frontend_panel_search_button_search")}
                                                    </Button>
                                                </div>
                                            </InputGroup>
                                        </div>
                                    </td>
                                </tr>
                            )
                        }
                        {
                            (this.state.isSelectionExpanded) && !_.isEmpty(this.state.indicators) && (
                                <tr className="row-select-indicator">
                                    <td className="column1-search">
                                        <span className="select-panel-row-title">
                                            {I18n.t("frontend_text_select_data_panel_select_data")}
                                        </span>
                                    </td>
                                    <td colSpan={2}>
                                        <PanelSelectIndicator
                                            indicators={this.state.indicators}
                                            onClickItem={(aoIndicator: any) => this.onPanelSelectIndicatorClickItem(aoIndicator)}
                                            selectedIndicatorId={_.isNil(this.state.indicator) ? undefined : this.state.indicator.indicatorID}
                                        />
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>

                {
                    this.props.caption2 && (
                        <div className="additional-data-advisory">
                            {this.props.caption2}
                        </div>
                    )
                }
            </div>
        );
    } // render

}


// Link with Redux store

const mapStateToProps =
    (state: any) => (
        {
            locale: state.i18n.locale,
            dataIndicatorsGet: (languageCode: string, id: number) => scwApi.endpoints.indicatorsGet.select({ "languageCode": languageCode, "id": id })(state),
            dataIndicatorsGetMetadata: (languageCode: string, id: number) => scwApi.endpoints.indicatorsGetMetadata.select({ "languageCode": languageCode, "id": id })(state),
            dataIndicatorsGetOfCategory: (languageCode: string, categoryId: number) => scwApi.endpoints.indicatorsGetOfCategory.select({ "languageCode": languageCode, "categoryId": categoryId })(state),
            dataIndicatorsSearch: (languageCode: string, searchText: string) => scwApi.endpoints.indicatorsSearch.select({ "languageCode": languageCode, "searchText": searchText })(state),
        }
    );

const mapDispatchToProps =
    (dispatch: Function) => {
        return {
            scwApiIndicatorsGet: (languageCode: string, id: number) => dispatch(scwApi.endpoints.indicatorsGet.initiate({ languageCode, id })),
            scwApiIndicatorsGetMetadata: (languageCode: string, id: number) => dispatch(scwApi.endpoints.indicatorsGetMetadata.initiate({ languageCode: languageCode, id: id })),
            scwApiIndicatorsGetOfCategory: (languageCode: string, categoryId: number) => dispatch(scwApi.endpoints.indicatorsGetOfCategory.initiate({ languageCode, categoryId })),
            scwApiIndicatorsSearch: (languageCode: string, searchText: string) => dispatch(scwApi.endpoints.indicatorsSearch.initiate({ languageCode: languageCode, searchText: searchText })),
        }
    };

export default connect(mapStateToProps, mapDispatchToProps)(PanelSelectData);